import React from 'react';
const bonuses = [{
  id: 'BONO 01',
  title: 'KIT 2 AM DE RESCATE RÁPIDO',
  description: 'Primeros Auxilios para la mente. Protocolo de 5 pasos + 12 tarjetas imprimibles para bajar el pico de ansiedad en minutos.',
  price: '$10.000'
}, {
  id: 'BONO 02',
  title: 'PLANNER CIERRE DEL DÍA',
  description: '14 noches guiadas para instalar el hábito. Tracker + plantillas diarias + reset sin culpa. Versión imprimible y móvil.',
  price: '$12.000'
}, {
  id: 'BONO 03',
  title: 'SCRIPTS: LÍMITES CON LA MENTE',
  description: '40 respuestas listas para pensamientos intrusivos. 6 categorías de rumiación con sus scripts exactos. Imprimible y descargable.',
  price: '$13.000'
}];
export function Bonuses() {
  return <section className="bg-cream py-12 md:py-24 px-4" data-id="element-138">
      <div className="max-w-6xl mx-auto text-center" data-id="element-139">
        <p className="text-sage font-sans font-medium tracking-[3px] text-sm mb-4 uppercase" data-id="element-140">
          🎁 3 BONOS ESTRATÉGICOS
        </p>
        <h2 className="font-sans font-light text-taupe text-lg mb-16" data-id="element-141">
          Valor total bonos: $35.000 →{' '}
          <span className="font-bold text-sage" data-id="element-142">GRATIS con tu colección</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-143">
          {bonuses.map((bono, i) => <div key={i} className="bg-white p-10 rounded-xl shadow-sage-soft border-t-4 border-gold relative text-left" data-id="element-144">
              <div className="absolute top-4 right-4 bg-gold text-sage-dark font-sans font-bold py-1 px-3 rounded-full text-[10px] uppercase" data-id="element-145">
                GRATIS
              </div>
              <p className="text-sage font-sans font-bold text-xs mb-4" data-id="element-146">
                {bono.id}
              </p>
              <h3 className="font-display font-bold text-navy text-xl mb-4" data-id="element-147">
                {bono.title}
              </h3>
              <p className="text-taupe font-sans text-sm leading-relaxed mb-8" data-id="element-148">
                {bono.description}
              </p>
              <p className="text-taupe line-through text-sm" data-id="element-149">{bono.price}</p>
            </div>)}
        </div>
      </div>
    </section>;
}